<template id="rolePermission">
  <div id="roleTree">
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">建立角色</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">角色</li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'roleList' }">角色列表</router-link>
              </li>
              <li class="breadcrumb-item active">建立角色</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <div class="content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-md-8 col-sm-12">
            <div class="card card-primary">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-8">
                    <el-form
                      ref="roleform"
                      :model="roleModel"
                      :rules="roleRules"
                      label-width="120px"
                    >
                      <el-form-item label="角色名稱" prop="sgL_RoleName">
                        <el-input v-model="roleModel.sgL_RoleName"></el-input>
                      </el-form-item>
                      <el-form-item label="備註">
                        <el-input v-model="roleModel.sgL_Remark"></el-input>
                      </el-form-item>
                      <el-form-item label="存取權限">
                        <el-button @click="changefold()">{{
                          status
                        }}</el-button>
                        <el-tree
                          :data="getPermissionList"
                          ref="permissiontree"
                          show-checkbox
                          expand
                          node-key="id"
                          :default-expand-all="false"
                          :default-checked-keys="getcheckList"
                          :props="defaultProps"
                        ></el-tree>
                      </el-form-item>
                      <el-form-item>
                        <el-button @click="addrole('roleform')">保存</el-button>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
  data() {
    return {
      roleModel: {
        roleName: "",
        remark: "",
      },
      status: "展開",
      foldbtn: false,
      //默认选中
      checkList: [], // ['1014'],
      roleRules: {
        sgL_RoleName: [
          {
            required: true,
            message: "請輸入角色名稱",
            trigger: "blur",
          },
        ],
      },
      checkKeys: [],
      permissionList: [],
      defaultProps: {
        id: "id",
        children: "menuPermissionDto",
        label: "lable",
      },
    };
  },
  created() {
    this.getAllPermission();
    let Id = this.$route.query.Id;
    if (Id != undefined && Id != "") {
      this.GetRole(Id);
    }
  },
  methods: {
    addrole(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (
            this.roleModel.id != "" &&
            this.roleModel.id != null &&
            this.roleModel.id > 0
          ) {
            //修改
            console.log("修改");
            this.checkKeys = this.$refs.permissiontree.getCheckedKeys(true);
            let params = {
              id: this.roleModel.id,
              sgL_RoleName: this.roleModel.sgL_RoleName,
              sgL_Remark: this.roleModel.sgL_Remark,
              sgL_ActionList: this.checkKeys.toString(),
            };
            this.$api.permissionApi.updateRole(params).then((res) => {
              if (res.data.success) {
                Message({
                  type: "success",
                  message: "修改成功",
                });
                this.$router.push({ name: "roleList" });
              } else {
                Message({
                  type: "error",
                  message: "修改失敗",
                });
              }
            });
          } else {
            console.log("新增");
            this.checkKeys = this.$refs.permissiontree.getCheckedKeys(true);
            let params = {
              sgL_RoleName: this.roleModel.sgL_RoleName,
              sgL_Remark: this.roleModel.sgL_Remark,
              sgL_ActionList: this.checkKeys.toString(),
            };
            this.$api.permissionApi.AddRolePermissions(params).then((res) => {
              if (res.data.success) {
                Message({
                  type: "success",
                  message: "添加成功",
                });
                this.$router.push({ name: "roleList" });
              } else {
                Message({
                  type: "error",
                  message: "添加失敗",
                });
              }
            });
          }
        } else {
          Message({
            type: "error",
            message: "請填寫必填數據",
          });
          return false;
        }
      });
    },
    changefold() {
      this.foldbtn = !this.foldbtn;
      if (this.foldbtn == true) {
        this.status = "展開";
      } else {
        this.status = "收起";
      }
      for (
        var i = 0;
        i < this.$refs.permissiontree.store._getAllNodes().length;
        i++
      ) {
        this.$refs.permissiontree.store._getAllNodes()[
          i
        ].expanded = this.foldbtn;
      }
    },
    GetRole(id) {
      let params = {
        Id: id,
      };
      this.$api.permissionApi.GetRole(params).then((res) => {
        if (res.data.success) {
          this.roleModel = res.data.result;
          this.checkList = res.data.result.menuPermissionDtoAry;
          // res.data.result.menuPermissionDtoAry.map((res) => {
          //   // this.checkList = new Array();
          //   this.checkList.length = 0;
          //   this.checkList.push(res);
          // });
        } else {
          Message({
            type: "error",
            message: "编辑失败",
          });
          this.$router.push({ name: "roleList" });
        }
      });
    },
    //获取所有菜单权限
    getAllPermission() {
      this.$api.permissionApi.GetAllPermission().then((res) => {
        res.data.result.defaultCheck.map((check) => {
          this.checkList.push(check);
        });
        this.permissionList = res.data.result.menuPermissions;
        // console.log(this.permissionList);
        for(let idx = 0; idx < this.permissionList.length; idx++) {
          this.setLabelRouter(this.permissionList[idx]);
        }
      });
    },
    setLabelRouter(labelRouter) {
      if(labelRouter.sgL_IsActive !== undefined){
        for(let i = 0; i < labelRouter.menuPermissionDto.length; i++){
          this.setLabelRouter(labelRouter.menuPermissionDto[i]);
        }
      }else{
        labelRouter.lable = `${labelRouter.lable} ( ${labelRouter.sgL_ControlName}/${labelRouter.sgL_ActionName} )`;
      }
    },
  },
  computed: {
    getPermissionList() {
      return this.permissionList;
    },
    getroleModel() {
      return this.roleModel;
    },
    getcheckList() {
      return this.checkList;
    },
    getfoldbtn() {
      return this.foldbtn;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/AdminUser/rolePermissions.vue